import {useState} from 'react';
import {useQuery} from '@apollo/client';
import {unwrap} from 'pages/kybDashboard/kybUtils';
import {hubListInput} from './kycHubUtils';

/**
 * One paginated Hub list: its filters, its page and the rows.
 *
 * A filter change goes through `setFilter`, which also drops back to page 1 in
 * the same render — the numbering no longer means anything, and resetting in
 * an effect would first fetch the stale page.
 */
export const useHubList = (query, field, subject, initialFilters = {}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [page, setPage] = useState(1);

  const {data, loading, error} = useQuery(query, {
    variables: {input: hubListInput(subject, page, filters)},
    fetchPolicy: 'cache-and-network',
    skip: !subject.subjectId,
  });

  const result = data?.[field];
  const {data: rows, error: responseError} = unwrap(result);

  return {
    rows: rows || [],
    total: result?.pagination?.total || 0,
    loading,
    error:
      responseError ||
      (error && !result ? 'Could not load this list. Try again.' : null),
    filters,
    setFilter: patch => {
      setFilters(current => ({...current, ...patch}));
      setPage(1);
    },
    page,
    setPage,
  };
};
